import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, MapPin, Phone } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [showTmModal, setShowTmModal] = useState(false);

  return (
    <footer className="bg-gradient-to-b from-red-900 to-black text-gray-300">
      {/* Main Footer */}
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Column */}
          <div className="col-span-1">
            <div className="flex items-center mb-6 relative">
              <div className="w-[64px] h-auto mr-3 overflow-hidden rounded border-2 border-amber-500 shadow-lg shadow-amber-900/40">
                <img
                  src="https://ik.imagekit.io/devhm/WhatsApp%20Image%202025-06-04%20at%2012.29.09.jpeg?updatedAt=1749036856478"
                  alt="Grand Cinemaz Logo"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex flex-col">
                <span className="font-bold text-xl tracking-tight text-amber-400">
                  GRAND CINEMAZ Pvt. Ltd.
                </span>
                {/* Tiny TM ribbon */}
              </div>
            </div>
            <p className="text-sm mb-6 text-gray-300 leading-relaxed">
              Experience cinema like never before with the latest blockbusters,
              premium seating, and state-of-the-art sound and projection. Where
              movie magic comes to life!
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                aria-label="Facebook"
                className="bg-red-900/40 hover:bg-amber-600 text-amber-300 hover:text-red-950 p-2 rounded-full transition-all duration-300"
              >
                <Facebook size={18} />
              </a>
              <a
                href="#"
                aria-label="Twitter / X"
                className="bg-red-900/40 hover:bg-amber-600 text-amber-300 hover:text-red-950 p-2 rounded-full transition-all duration-300"
              >
                <Twitter size={18} />
              </a>
              <a
                href="#"
                aria-label="Instagram"
                className="bg-red-900/40 hover:bg-amber-600 text-amber-300 hover:text-red-950 p-2 rounded-full transition-all duration-300"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-span-1">
            <h3 className="text-amber-400 font-semibold text-lg mb-5 pb-2 border-b border-red-800/50">
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/shows"
                  className="hover:text-amber-300 transition-colors duration-300 flex items-center"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-600 mr-2"></span>
                  Now Showing
                </Link>
              </li>
              <li>
                <Link
                  to="/movies"
                  className="hover:text-amber-300 transition-colors duration-300 flex items-center"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-600 mr-2"></span>
                  Movies
                </Link>
              </li>
              <li>
                <Link
                  to="/offers"
                  className="hover:text-amber-300 transition-colors duration-300 flex items-center"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-600 mr-2"></span>
                  Offers & Promotions
                </Link>
              </li>
            </ul>
          </div>

          {/* About Us */}
          <div className="col-span-1">
            <h3 className="text-amber-400 font-semibold text-lg mb-5 pb-2 border-b border-red-800/50">
              About Us
            </h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://devbhoomigroup.in/about"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-amber-300 transition-colors duration-300 flex items-center"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-600 mr-2"></span>
                  Our Legacy
                </a>
              </li>
              <li>
                <Link
                  to="/about"
                  className="hover:text-amber-300 transition-colors duration-300 flex items-center"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-600 mr-2"></span>
                  About Grand Cinemaz
                </Link>
              </li>
              <li>
                <Link
                  to="/team"
                  className="hover:text-amber-300 transition-colors duration-300 flex items-center"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-600 mr-2"></span>
                  Grand Cinemaz Team
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="hover:text-amber-300 transition-colors duration-300 flex items-center"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-600 mr-2"></span>
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/faqs"
                  className="hover:text-amber-300 transition-colors duration-300 flex items-center"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-600 mr-2"></span>
                  FAQs
                </Link>
              </li>
              <li>
                <Link
                  to="/termsandconditions"
                  className="hover:text-amber-300 transition-colors duration-300 flex items-center"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-600 mr-2"></span>
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact + Trademark */}
          <div className="col-span-1">
            <h3 className="text-amber-400 font-semibold text-lg mb-5 pb-2 border-b border-red-800/50">
              Contact Us
            </h3>

            <p className="text-amber-300 font-semibold text-base mb-4">
              Grand Cinemaz Pvt. Ltd.
            </p>

            <ul className="space-y-4">
              <li className="flex items-start group">
                <MapPin
                  size={18}
                  className="mr-2 mt-1 flex-shrink-0 text-amber-500 group-hover:text-amber-300 transition-colors duration-300"
                />
                <a
                  href="https://devbhoomigroup.in/about"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group-hover:text-amber-100 transition-colors duration-300 hover:underline underline-offset-2"
                >
                  Dev Bhoomi Group Companies, Admin Block at The Gulmohar Grand,
                  8 mile stone, Una Chandigarh Highway Behdala, Una, Himachal
                  Pradesh 174306
                </a>
              </li>

              <li className="flex items-center group">
                <Phone
                  size={18}
                  className="mr-2 flex-shrink-0 text-amber-500 group-hover:text-amber-300 transition-colors duration-300"
                />
                <a
                  href="tel:+919115110122"
                  className="group-hover:text-amber-100 transition-colors duration-300"
                >
                  +91 91151 10122
                </a>
              </li>

              {/* Trademark & Legal */}
              <li className="pt-2 mt-2 border-t border-red-800/40">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h4 className="text-amber-300 font-medium">
                      Trademark & Legal
                    </h4>
                    <p className="text-xs text-amber-200/90 mt-1 leading-relaxed">
                      <span className="font-semibold">DB GRAND CINEMAZ</span> is
                      a registered trademark (No.{" "}
                      <span className="font-mono">3627012</span>) in Class 41
                      for cinema & entertainment services.
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={() => setShowTmModal(true)}
                    className="text-xs px-3 py-1 rounded bg-amber-500/10 text-amber-300 border border-amber-400/30 hover:bg-amber-500/20 transition"
                    title="Open Trademark Certificate"
                  >
                    View Certificate
                  </button>
                </div>
                <a
                  href="https://ik.imagekit.io/devhm/showdocument.aspx%20(1).pdf?updatedAt=1755495945166"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[12px] inline-block mt-2 text-amber-300 hover:underline underline-offset-2"
                >
                  Download certificate (PDF)
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Awards and Certifications */}
      <div className="max-w-6xl mx-auto px-4 py-8 border-t border-red-900/30">
        {" "}
        <div className="flex flex-wrap justify-center gap-8 md:gap-12">
          {" "}
          <div className="flex flex-col items-center">
            {" "}
            <div className="w-12 h-12 bg-amber-900/30 rounded-full flex items-center justify-center mb-2">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-6 h-6 text-amber-400"
              >
                {" "}
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>{" "}
              </svg>{" "}
            </div>{" "}
            <span className="text-xs text-center text-amber-200">
              {" "}
              Best Theater Experience 2024{" "}
            </span>{" "}
          </div>{" "}
          <div className="flex flex-col items-center">
            {" "}
            <div className="w-12 h-12 bg-amber-900/30 rounded-full flex items-center justify-center mb-2">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-6 h-6 text-amber-400"
              >
                {" "}
                <rect
                  x="3"
                  y="11"
                  width="18"
                  height="11"
                  rx="2"
                  ry="2"
                ></rect>{" "}
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>{" "}
              </svg>{" "}
            </div>{" "}
            <span className="text-xs text-center text-amber-200">
              {" "}
              Certified Security Standards{" "}
            </span>{" "}
          </div>{" "}
          <div className="flex flex-col items-center">
            {" "}
            <div className="w-12 h-12 bg-amber-900/30 rounded-full flex items-center justify-center mb-2">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-6 h-6 text-amber-400"
              >
                {" "}
                <path d="M20.2 5.9l.9-.9c.5-.5.5-1.4 0-1.9s-1.4-.5-1.9 0l-.9.9"></path>{" "}
                <path d="M18.3 7.8l2-2"></path>{" "}
                <path d="M9 17l-4.6 4.6c-.5.5-1.4.5-1.9 0s-.5-1.4 0-1.9L7 15"></path>{" "}
                <path d="M14.5 7.5L8 14"></path>{" "}
                <path d="M18.3 11c1.9 4.7-1.2 9.8-5.9 11.8-4.7 1.9-9.8-1.2-11.8-5.9-1.9-4.7 1.2-9.8 5.9-11.8 2.8-1.1 5.8-.9 8.3.6"></path>{" "}
              </svg>{" "}
            </div>{" "}
            <span className="text-xs text-center text-amber-200">
              {" "}
              Premium Sound Quality{" "}
            </span>{" "}
          </div>{" "}
          <div className="flex flex-col items-center">
            {" "}
            <div className="w-12 h-12 bg-amber-900/30 rounded-full flex items-center justify-center mb-2">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-6 h-6 text-amber-400"
              >
                {" "}
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>{" "}
              </svg>{" "}
            </div>{" "}
            <span className="text-xs text-center text-amber-200">
              {" "}
              5-Star Customer Rating{" "}
            </span>{" "}
          </div>{" "}
        </div>{" "}
      </div>  

      {/* Bottom Footer */}
      <div className="bg-black py-6">
        <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-center md:text-left mb-4 md:mb-0">
            &copy; {currentYear}{" "}
            <span className="text-amber-400">Grand Cinemaz</span>. All rights
            reserved.
          </p>
          <p className="text-[12px] text-amber-200/80">
            DB GRAND CINEMAZ® — TM No. 3627012 (Class 41)
          </p>
        </div>
      </div>

      {/* TM Modal */}
      {showTmModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70"
          onClick={() => setShowTmModal(false)}
        >
          <div
            className="w-full max-w-3xl bg-zinc-950 border border-amber-500/20 rounded-2xl shadow-2xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="px-5 py-4 border-b border-amber-500/20 flex items-center justify-between">
              <h3 className="text-amber-300 font-semibold">
                Trademark Certificate — DB GRAND CINEMAZ
              </h3>
              <button
                onClick={() => setShowTmModal(false)}
                className="text-amber-200 hover:text-white"
                aria-label="Close"
              >
                ✕
              </button>
            </div>
            <div className="p-4">
              <iframe
                title="Trademark Certificate"
                src="https://ik.imagekit.io/devhm/showdocument.aspx%20(1).pdf?updatedAt=1755495945166"
                className="w-full h-[70vh] rounded-md border border-amber-500/10"
              />
              <div className="mt-3 text-xs text-amber-200/80">
                Registered owner: Rajinder Vashista trading as Dev Bhoomi
                Gulmohar Grand Hotel • Registry: Mumbai • Application date: 04
                Sep 2017 • Certificate sealed: 26 Feb 2018
              </div>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
